import 'react';
import { BsStopwatch } from '@react-icons/all-files/bs/BsStopwatch';
import { LIGHT_THEME } from '@bucketplace/design-system';
import { decorateComponent } from '../../documentComponents/decorateComponent.js';
import { Countdown as Countdown$1 } from './Countdown.js';
import { CountdownInspector } from './Countdown.Inspector.js';
import { jsx } from '@emotion/react';

var Countdown = decorateComponent(Countdown$1, 'block', {
  id: 'countdown',
  label: '카운트다운',
  allowedChildren: [],
  allowedParent: ['page', 'block'],
  defaultProps: {
    duration: {},
    timerPrefix: 'start',
    align: 'left',
    color: LIGHT_THEME.base.neutral600
  },
  renderIcon: function renderIcon() {
    return jsx(BsStopwatch, null);
  },
  renderInspector: CountdownInspector
});

export { Countdown as default };
//# sourceMappingURL=index.js.map
